 import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { catchError, EMPTY, map, Observable, tap, throwError } from 'rxjs';
   
@Injectable({
  providedIn: 'root'
})

export class BoletoService {
  private apiUrl = 'https://site-geia.azurewebsites.net/Home/GeraCriptoNew';

  constructor(private httpClient: HttpClient,
     ) { } 
    getInfoBoleto(doc: any): Observable<any> { 
      return this.httpClient.post<any>(`https://site-geia.azurewebsites.net/Home/GeraCriptoNew?doc=${doc}`,{})
    .pipe(
      map(response => { 
        return response
      }),
      catchError(err => { 
        console.log("Erro ao processar os dados:" , err)
        return throwError(() => new Error(err || "Erro no servidor"))
       })
    ); 
    }
 
 
}
